import { Link } from 'react-router-dom';
import LegalPage, { MailLink, Section } from './LegalPage';

const linkClass = 'text-primary underline-offset-4 hover:underline';

const PrivacyPolicy = () => (
  <LegalPage
    title="Privacy Policy"
    description="How KZcomp.com processes personal data."
    path="/privacy"
  >
    <Section title="1. Controller">
      <p>
        The controller within the meaning of the GDPR is the operator named in the{' '}
        <Link to="/imprint" className={linkClass}>
          Legal Notice
        </Link>
        . Contact: <MailLink />
      </p>
    </Section>

    <Section title="2. Website access">
      <p>
        When you visit the website, technical data such as your IP address, the requested page and
        browser information are processed to deliver the website and keep it secure (Art. 6 (1) (f)
        GDPR). Server logs are deleted automatically after a short period. The website is hosted by
        a hosting provider acting on our behalf.
      </p>
    </Section>

    <Section title="3. User accounts">
      <p>
        If you create an account, we process the data you provide, such as your email address,
        username, profile information, linked accounts and tournament participation, to provide
        your account and our features (Art. 6 (1) (b) GDPR). Accounts are provided using Google
        Firebase; data may be processed in the USA, based on the EU–US Data Privacy Framework.
        Account data is kept until your account is deleted. Public tournament results may be kept
        as part of the historical record (Art. 6 (1) (f) GDPR).
      </p>
    </Section>

    <Section title="4. Contact">
      <p>
        If you contact us, we process your details and message to handle your request (Art. 6 (1)
        (b) or (f) GDPR).
      </p>
    </Section>

    <Section title="5. Browser storage">
      <p>
        We store technically necessary information in your browser, such as your login session and
        display settings (§ 25 (2) No. 2 TDDDG).
      </p>
    </Section>

    <Section title="6. Third-party content">
      <p>
        Some pages load content from third parties, such as Twitch and YouTube embeds, flag images
        and map data. When this content is loaded, the provider receives your IP address and may
        process it in the USA (Art. 6 (1) (f) GDPR).
      </p>
    </Section>

    <Section title="7. Your rights">
      <p>
        You have the right to access, rectification, erasure, restriction of processing, data
        portability and to object to processing, and to withdraw consent at any time. Contact us at{' '}
        <MailLink />. You may also lodge a complaint with a data protection supervisory authority.
      </p>
    </Section>
  </LegalPage>
);

export default PrivacyPolicy;
